<template>
    <div>
        <ValidationObserver ref="formModalValidate">
           <b-row>
                <b-col cols="12" md="6">
                  <ValidationProvider name="name" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_name')">
                            <b-form-input :validate-error="errors[0]" v-model="form.name">
                            </b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="type" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('club_type')">
                            <parameter-selectbox v-model="form.type"
                                                 :validate-error="errors[0]" code="student_club_types"></parameter-selectbox>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="status" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('status')">
                            <status-selectbox v-model="form.status" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="creation_date" rules="required" v-slot="{ valid, errors }">
						<b-form-group :label="$t('foundation_at')">
                            <select-date v-model="form.creation_date" :state="errors[0] ? false : null" />
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]" />
						</b-form-group>
					</ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="president_id" rules="required" v-slot="{errors}">
                        <b-form-group :label="$t('club_president')">
                            <students-auto-complete-by-key
                                :value="selectedPresident"
                                @user-input="handleSelection"
                                :valueObject="presidentValue"
                                :validate-error="errors[0]" />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="instructor_id" rules="required" v-slot="{valid, errors}">
                        <b-form-group :label="$t('academic_advisor')">
                            <staff-auto-complete v-model="form.instructor_id"
                                                 :valueObject="instructorValue"
                                                 :validateError="errors[0]"
                            />
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
                <b-col cols="12" md="6">
                    <ValidationProvider name="dues" rules="required" v-slot="{ valid, errors }">
                        <b-form-group :label="$t('fee')">
                            <b-form-input step="0.01" v-model="form.dues"></b-form-input>
                            <b-form-invalid-feedback v-if="errors[0]" v-html="errors[0]"></b-form-invalid-feedback>
                        </b-form-group>
                    </ValidationProvider>
                </b-col>
            </b-row>
            <b-button
                    @click="updateForm"
                    type="button"
                    :disabled="formLoading"
                    variant="primary"
                    class="btn-lg mr-2"
            >
                {{ $t("save") | toUpperCase }}
            </b-button>
        </ValidationObserver>
    </div>
</template>

<script>
    //Component
    import ParameterSelectbox from "@/components/interactive-fields/ParameterSelectbox";
    import StatusSelectbox from "@/components/interactive-fields/StatusSelectbox";
    import StaffAutoComplete from '@/components/interactive-fields/StaffAutoComplete';
    import StudentsAutoCompleteByKey from "@/components/interactive-fields/StudentsAutoCompleteByKey"

    //Other
    import {ValidationProvider, ValidationObserver} from "vee-validate"
    //Service
    import StudentClubService from "@/services/StudentClubService";

    export default {
        components: {
            StudentsAutoCompleteByKey,
            ValidationProvider,
            ValidationObserver,

            ParameterSelectbox,
            StatusSelectbox,
            StaffAutoComplete
        },
        props: {
            formId: {
                type: Number,
            }
        },
        data() {
            return {
                formLoading: false,
                instructorValue: {},
                presidentValue: {},
                selectedPresident: '',
                form: {
                    //
                }
            }
        },
        watch: {
            formId: function (val) {
                this.get(val)
            }
        },
        async created() {
            await this.get(this.formId)
        },
        methods: {
            get(id) {
                this.formLoading = true;
                StudentClubService.get(id)
                               .then((response) => {
                                   this.form = response.data.data;
                                   if (typeof this.form.status === 'boolean') {
                                       this.form.status = this.form.status ? 'a' : 'p';
                                   }
                                   if (this.form.instructor_id) {
                                       this.instructorValue = { value: this.form.instructor_id, text: this.form.instructor.name + ' ' + this.form.instructor.surname }
                                   }
                                   if (this.form.president_id) {
                                       const fullName = `${this.form.president.name} ${this.form.president.surname}`;
                                       this.selectedPresident = fullName;
                                       this.presidentValue = {
                                           value: this.form.president_id,
                                           text: fullName
                                       };
                                   }
                                   this.formLoading = false;
                               })
                               .catch((error) => {
                                   if (error.data.message) {
                                       this.$toast.error(this.$t("api." + error.data.message));
                                   }
                               });
            },
            async updateForm() {
                const isValid = await this.$refs.formModalValidate.validate();
                if (isValid && this.formId) {
                    this.formLoading = true;
                    this.form.dues = parseFloat(this.form.dues).toFixed(2);
                    if (this.form.status === 'p') {
                        this.form.status = 0;
                    } else if (this.form.status === 'a') {
                        this.form.status = 1;
                    }
                    StudentClubService.update(this.formId, this.form)
                                   .then((response) => {
                                       this.formLoading=false;
                                       this.$toast.success(this.$t("api." + response.data.message));
                                       this.$emit("updateFormSuccess")
                                   })
                                   .catch((error) => {
                                       this.showErrors(error, this.$refs.formModalValidate)
                                   })
                }
            },
            handleSelection(user) {
                this.form.president_id = user?.user_id;
                this.selectedPresident = user ? `${user.name} ${user.surname}` : '';
            }
        }
    }
</script>
